import React, { useEffect, useState } from "react";
import { Box, Flex, Heading, Text, Badge, useColorModeValue } from "@chakra-ui/react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./LandingPageComponent.css";
import Card from "./Card";
import LoadingComponent from "../LoadingComponents/LoadingComponent";

const LandingPageCarousel = () => {
  const [loading, setLoading] = useState(true);
  const [course, setCourse] = useState([]);
  const arr = [1, 2, 3, 4];
  var settings = {
    swipe: true,
    dots: true,
    infinite: course.length > 4,
    speed: 500,
    slidesToShow: Math.min(course.length || 4, 4),
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(course.length || 4, 4),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(course.length || 3, 3),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: Math.min(course.length || 2, 2),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const url = `${process.env.REACT_APP_API_URL}/api/courses`;
    setLoading(true);

    const token = JSON.parse(localStorage.getItem("user"))?.token || "";
    const headers = {};
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    fetch(url, { headers })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        setCourse(data.course || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  }, []);

  return (
    <Flex direction="column" py={12} px={{ base: 6, md: 12 }} maxW="1400px" w="full" mx="auto">
      <Box mb={8} px={6}>
        <Badge 
          colorScheme="blue" 
          variant="subtle" 
          px={3} 
          py={1} 
          borderRadius="full" 
          fontSize="10px" 
          fontWeight="800"
          letterSpacing="0.5px"
          textTransform="uppercase"
          mb={3}
        >
          🔥 Top Programs
        </Badge>
        <Heading
          fontSize={{ base: "3xl", md: "4xl" }}
          fontWeight="850"
          letterSpacing="-1.5px"
          color={useColorModeValue("gray.800", "white")}
        >
          Popular Training Modules
        </Heading>
        <Text fontSize="sm" color={useColorModeValue("gray.500", "gray.400")} mt={1}>
          Highly rated courses recommended for professional credentials and team compliance
        </Text>
      </Box>

      <Box px={2}>
        <Slider {...settings}>
          {!loading
            ? course?.map((el) => <Card {...el} key={el._id} />)
            : arr.map((el, i) => <LoadingComponent key={i} />)}
        </Slider>
      </Box>
    </Flex>
  );
};

export default LandingPageCarousel;
